import React from "react";
import AssetCard from "./AssetCard";

const BrandSection = ({ assetDetails, assets }) => {
  console.log(assetDetails);
  return (
    <section className="brand-section">
      <h2>{assetDetails.brandName}</h2>
      {assetDetails.website && (
        <a href={assetDetails.website} target="_blank" rel="noreferrer">
          {assetDetails.website}
        </a>
      )}
      <p>{assetDetails.description}</p>
      <div className="asset-grid">
        {assets.map((asset, index) => (
          <AssetCard key={index} name={asset.name} src={asset.src} />
        ))}
      </div>
    </section>
  );
};

export default BrandSection;
